import styled from 'styled-components';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import { StyledLink } from '../styles/ui';
import { HEADER_TYPE } from '../types';
import { fontSemibold16, fontRegular16 } from '../styles/fonts';
import { Colors } from '../../../theme';
import { breakpointLG } from '../styles/breakpoints';
export const CustomNav = styled.nav `
  display: none;
  margin-left: 64px;

  @media (min-width: ${breakpointLG}) {
    display: ${(props) => (props.$type === HEADER_TYPE.Integrated ? 'none' : 'block')};
  }
`;
export const CustomList = styled.ul `
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  list-style-type: none;
`;
export const CustomListItem = styled.li `
  display: flex;
  align-items: center;
  margin-right: 8px;

  &:last-of-type {
    margin-right: 0;
  }

  .avatarButton {
    &:hover {
      background-color: transparent;
    }
  }

  .avatarName {
    ${fontRegular16}
    color: ${Colors.blue60};
    background-color: ${Colors.blue10};
  }

  .avatarIcon {
    margin-left: 8px;
    color: ${Colors.black80};
    transform: rotate(-90deg);
  }
`;
export const CustomLink = styled(StyledLink) `
  padding: 8px 16px;
  ${fontSemibold16}
  border-radius: 4px;
`;
export const CustomBadge = styled(Badge) `
  .MuiBadge-badge {
    right: -8px;
  }
`;
export const CustomBox = styled(Box) `
  display: flex;
  column-gap: 16px;
  align-items: center;
`;
//# sourceMappingURL=styles.js.map